export default __webpack_public_path__ + "static/media/G_D_btn_lego.0da63682.svg";